<template>
  <div>
    <search-bar @onSearch="onSearch" ref="sbar"></search-bar>
    <swiper-item :params="params"></swiper-item>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      v-if="!isNodata"
    >
      <van-cell v-for="(item,index) in list" :key="index" @click="toDetails(item.foodId)">
        <list-item :data="item"></list-item>
      </van-cell>
    </van-list>
    <div v-if="isNodata" class="no-data-tips">
      <div class="tips">
        <div class="tips-img">
          <img src="@/assets/images/icon_no_search_content.png" alt>
        </div>
        <p class="tips-txt">抱歉，共搜索到0条记录</p>
        <!-- <Button class="tips-feedback" @click="toFeedBack">点我进行反馈</Button> -->
      </div>
    </div>
  </div>
</template>
<script>
import SearchBar from "@/view/eating/components/search-bar";
import ListItem from "@/view/eating/components/list-item";
import { List, Cell } from "vant";
import { getFoodList } from "@/api/eating.js";
import wx from "weixin-js-sdk";
import shareImg from "@/assets/images/home_ic_cye@3x.png";
import SwiperItem from "@/view/eating/components/swiper-item";
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      foodName: "",
      foodTypeId: "",
      pageNumber: 0,
      pageSize: 40,
      isNodata: false,
      shareImg: shareImg,
      params: {
        phaseInquire: 0,
        bannerQuantity: 100,
        businessKey: this.$isWechat? 'GZH_WHETHER_CAN_EAT_LIST': 'APP_WHETHER_CAN_EAT_LIST'
      }
    };
  },
  components: { SwiperItem, SearchBar, ListItem, [List.name]: List, [Cell.name]: Cell },
  created() {
    const shareTitle = "孕e家-能不能吃工具";
    const shareDesc =
      "孕期禁忌千万条，靠谱安全第一条。孕e家能不能吃小工具，一查就知道！";
    const imgUrl = this.getFullImgUrl(shareImg);
    wx.ready(function() {
      //需在用户可能点击分享按钮前就先调用
      wx.updateAppMessageShareData({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function() {
          // 设置成功
          console.log("分享成功");
        },
        cancal: function() {}
      });
      wx.updateTimelineShareData({
        title: shareTitle, // 分享标题
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function() {
          // 设置成功
          console.log("分享成功");
        }
      });
    });
  },
  mounted() {
    this.$refs.sbar.value = this.$route.query.foodName;
    this.foodName = this.$route.query.foodName;
    this.foodTypeId = this.$route.query.foodTypeId;
  },

  methods: {
    async onLoad() {
      this.isNodata = false;
      this.pageNumber = this.pageNumber + 1;
      const res = await getFoodList(
        this.$route.query.foodTypeId,
        encodeURIComponent(this.$route.query.foodName),
        this.pageNumber,
        this.pageSize
      );

      this.list = [...this.list, ...(res.data.list ? res.data.list : [])];
      // 加载状态结束
      this.loading = false;

      if (this.list.length == 0) {
        this.finished = true;
        this.isNodata = true;
      }

      // 数据全部加载完成
      if (this.list.length >= res.data.total) {
        this.finished = true;
      }
    },
    onSearch(keyWord) {
      this.foodName = keyWord;
      this.$router.replace({
        path: "/eating/list",
        query: { foodName: keyWord, foodTypeId: this.foodTypeId }
      });
      this.list = [];
      this.pageNumber = 0;
      this.onLoad();
    },
    toDetails(foodId) {
      this.$router.push({
        path: "/eating/details",
        query: { foodId: foodId }
      });
    },
    toFeedBack() {
      this.$router.push({
        path: "/eating/feedback"
      });
    },
    getFullImgUrl(shareImg) {
      return window.location.href.split("#")[0].replace(/index.html/, shareImg);
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log(to, from);
    if (to.path == "/eating/home") {
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  }
};
</script>
<style lang="less">
.van-cell {
  padding: 0;
}
.no-data-tips {
  position: fixed;
  width: 100%;
  height: calc(100% - 45px);
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
}
.tips {
  text-align: center;
  &-img {
    width: 119px;
    height: 121px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-txt {
    color: #999999;
    font-size: 14px;
  }
  &-feedback {
    width: 140px;
    height: 38px;
    background: rgba(255, 120, 158, 1);
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    border: 0;
  }
}
</style>

